import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree} from '@angular/router';

/** The organization in the URL; a guard's own route sits below the /o/:organization_id one. */
function organizationId(route: ActivatedRouteSnapshot): string {
  return route.pathFromRoot.map(r => r.paramMap.get('organization_id')).find(id => !!id) || '';
}

function hostList(route: ActivatedRouteSnapshot): UrlTree {
  return inject(Router).createUrlTree(['/o', organizationId(route), 'crd']);
}

/**
 * The session page needs the host's region to join. Links from before the screen tabs went to the
 * viewer with the join result (session, peer ids, password) instead: one-shot, stale on any reload,
 * and with no region to join again. Those go back to the host list, so the password leaves the URL too.
 */
export const crdSessionGuard: CanActivateFn = (route) =>
  route.queryParamMap.get('region') ? true : hostList(route);

/** The old per-screen join link (`crd/join/:pool/:hostId?monitor=N`) opens the session page on that screen. */
export const crdJoinRedirect: CanActivateFn = (route) => {
  const q = route.queryParamMap;
  if (!q.get('region')) {
    return hostList(route);
  }
  return inject(Router).createUrlTree(
    ['/o', organizationId(route), 'crd', 'view', route.paramMap.get('pool'), route.paramMap.get('hostId')],
    {queryParams: {hostName: q.get('hostName'), region: q.get('region'), monitor: q.get('monitor')}},
  );
};
